<!-- 解决方案服务 -->
<template>
  <div class="plan-service-view">
    <el-form :rules="rules">
      <p class="info-title">解决方案服务</p>

      <div class="plan-service-block">
        <el-form-item label="咨询服务:" label-width="180px">
          <Editorbar v-model="queryParams.advisoryService" />
        </el-form-item>

        <el-form-item label="实施服务:" label-width="180px">
          <Editorbar v-model="queryParams.implementServices" />
        </el-form-item>

        <el-form-item label="税费信息:" label-width="180px">
          <Editorbar v-model="queryParams.taxInformation" />
        </el-form-item>

        <el-form-item label="物流服务:" label-width="180px">
          <Editorbar v-model="queryParams.logisticsServices" />
        </el-form-item>

        <el-form-item label="培训服务:" label-width="180px">
          <Editorbar v-model="queryParams.trainingServices" />
        </el-form-item>

        <el-form-item label="售后服务:" label-width="180px">
          <Editorbar v-model="queryParams.afterSaleService" />
        </el-form-item>

        <el-form-item label="其他服务:" label-width="180px">
          <Editorbar v-model="queryParams.otherService" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
// 富文本编辑器
import Editorbar from "@/components/Editorbar.vue";
// api
import { getSolutionServiceBySolutionId, updateSolutionService } from "@/api/solvePlan.js";

export default {
  components: { Editorbar },
  data() {
    //这里存放数据
    return {
      rules: {},
      queryParams: {
        advisoryService: "", // 咨询服务
        afterSaleService: "", // 售后服务
        implementServices: "", // 实施服务
        logisticsServices: "", // 物流服务
        otherService: "", // 其他服务
        taxInformation: "", // 税费信息
        trainingServices: "", // 培训服务
      }
    };
  },
  methods: {
    getInfo() {
      getSolutionServiceBySolutionId({id: this.$route.query.companyCode}).then(res => {
        if(res.code == 200 && res.data) {
          this.queryParams = res.data;
        }
      })
    },
    submit() {
      this.$modal.loading('正在保存数据，请稍候...');

      updateSolutionService(this.queryParams).then(res => {
        if (res.code === 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    }
  }
};
</script>

<style scoped lang="less">
.info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }
</style>
